import React from "react";
import SetMessageComponent from "./SetMessageComponent";

function SetConfirmationMessage() {
  return (
    <SetMessageComponent
      messageType="email"
      title="Set Confirmation Message"
      description={`Enter the confirmation message template below. Here are the available tags to use: <name> the person's first name, <datestr> the date, <timestr> the time, and <link> the reschedule link.`}
    />
  );
}

export default SetConfirmationMessage;